const STATUS_SEARCH_MAP: Record<string, string> = {
  lulus: "approve",
  ditolak: "rejected",
  gagal: "rejected",
  tolak: "rejected",
  "sedang diproses": "pending",
  diproses: "pending",
  proses: "pending",
};

export function transformApplicationSearch(search: string) {
  let result = search;

  Object.entries(STATUS_SEARCH_MAP).forEach(
    ([keyword, replacement]) => {
      result = result.replace(
        new RegExp(keyword, "gi"),
        replacement,
      );
    },
  );

  return result;
}